import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.filterPrograms()

    // Écouter les changements de localStorage (quand user change dans settings)
    window.addEventListener('storage', (e) => {
      if (e.key === 'tv_hidden_channels') {
        this.filterPrograms()
      }
    })

    // Écouter les changements sur la même page
    document.addEventListener('channelPreferencesChanged', () => {
      this.filterPrograms()
    })
  }

  filterPrograms() {
    const hiddenChannels = this.getHiddenChannels()

    document.querySelectorAll('[id^="program-"]').forEach(programElement => {
      const channelId = programElement.id.replace('program-', '')

      if (hiddenChannels.includes(channelId)) {
        programElement.classList.add('hidden')
      } else {
        programElement.classList.remove('hidden')
      }
    })

    }

  getHiddenChannels() {
    try {
      const stored = localStorage.getItem('tv_hidden_channels')
      return stored ? JSON.parse(stored) : []
    } catch (e) {
            return []
    }
  }
}